import { Box, SxProps } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import { Filter, FilterList } from "@outschool/ui-components-website";
import { Checkbox } from "@outschool/ui-legacy-component-library";
import _ from "lodash";
import React from "react";

import * as Activity from "../../../shared/Activity";
import FilterActionButtons from "./desktop/FilterActionButtons";

export type AgeFilterProps = {
  value: Array<number>;
  onChange: (newValue: Array<number>) => void;
  onCancel: () => void;
  handleChangesExternally?: boolean;
  listSx?: SxProps;
};

export default function AgeFilter({
  value,
  onChange,
  onCancel,
  handleChangesExternally,
  listSx = {}
}: AgeFilterProps) {
  const { t } = useTranslation("client\\components\\search\\AgeFilters");
  const [ages, setAges] = React.useState(value || []);

  const ageOptions = Activity.toddlerClassAgeOptions.concat(
    Activity.ageOptions
  );

  const handleFilterChange = (value: number[]) => {
    setAges(value);
    if (handleChangesExternally) {
      onChange(value);
    }
  };

  return (
    <FilterList>
      <Filter title={t("Learner age")}>
        <Box
          sx={[
            (theme: $TSFixMe) => ({
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",

              [theme.breakpoints.up("md")]: {
                gridTemplateColumns: "repeat(4, 1fr)"
              },

              gridGap: "1em"
            }),
            ...(Array.isArray(listSx) ? listSx : [listSx])
          ]}
        >
          {ageOptions.map((age: number) => (
            <Checkbox
              key={age}
              id={`${age}`}
              label={`${age}`}
              checked={!!ages.find(a => a === age)}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                const checked = e.target.checked;
                handleFilterChange(
                  checked ? [...ages, age] : _.without(ages, age)
                );
              }}
            />
          ))}
        </Box>
      </Filter>
      {handleChangesExternally ? null : (
        <FilterActionButtons
          onApply={() => onChange(ages)}
          onCancel={onCancel}
        />
      )}
    </FilterList>
  );
}
